import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import TopbarComponent from "../../Services/TopbarComponent";
import AppbarComponent from "../../Services/AppbarComponent";
import { Col, Container, ThemeProvider } from "react-bootstrap";
import { AppBar, Box } from "@mui/material";
import theme from "../../Services/WsMuiTheme";
import { DateRange } from "../Dashboard/Company/CompanyDashboard";
import { Add, FlightTakeoffRounded } from "@mui/icons-material";
import { WebService } from "../../Services/WebService";
import { DateTime } from "luxon";
import { useDispatch, useSelector } from "react-redux";
import { WeeklyDatePicker } from "../Form";
import { eachDayOfInterval, format, isValid, parseISO } from "date-fns";

function ShiftBoard() {
  const MasterPageName = "Shift Board";
  const dispatch = useDispatch();
  const CompanyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});
  const [HolidayYear, setHolidayYear] = useState(DateTime.now().year);
  const [HolidayList, setHolidayList] = useState([]);

  const [Date_Range, setDate_Range] = useState("");

  const [ShiftData, SetShiftData] = useState([]);
  const [bData, setBData] = React.useState([
    {
      title: "Shifts",
      hrefLink: "#",
    },
    {
      title: "Shift Timings",
      hrefLink: "#",
    },
  ]);

  const getHolidayList = async () => {
    let details = await WebService({
      endPoint: `Holiday/FetchUA?CompanyId=${CompanyInfo.CompanyId}&Year=${HolidayYear}`,
    });

    setHolidayList(details);
  };


  const getWeeklyDates = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    if (!isValid(start) || !isValid(end) || start > end) {
      throw new RangeError('Invalid interval');
    }
  
    // Convert holiday list into a Map for quick lookup
    const holidayMap = new Map(
      HolidayList.map(h => [
        new Date(h.HolidayDate).toISOString().split('T')[0],
        h.HolidayName
      ])
    );
  
    return eachDayOfInterval({ start, end }).map(date => {
      const fullDate = format(date, 'yyyy-MM-dd');
      const holidayName = holidayMap.get(fullDate);
      return {
        day: format(date, 'EEEE'),        // Monday, Tuesday, ...
        date: format(date, 'dd'),         // 01, 02, ...
        month: format(date, 'MMMM'),      // April, May, ...
        fullDate,                         // 2025-04-22
        holiday: !!holidayName,
        holidayName: holidayName || null
      };
    });
  };
  
  useEffect(() => {
    if (HolidayYear && CompanyInfo) getHolidayList();
  }, [HolidayYear, CompanyInfo.CompanyId]);

  const WeekDays = useMemo(() => {
    const startDate = Date_Range.StartDate;
    const endDate = Date_Range.EndDate;

    if (startDate && endDate) {
      return getWeeklyDates(startDate, endDate);
    }

    return [];
  }, [Date_Range.StartDate, Date_Range.EndDate]);
  const formatted = ShiftData.map((emp) => {
    const empLeaves = new Set(emp.leaves); // faster lookup
    const shifts = WeekDays.map((date) =>
      empLeaves.has(date.fullDate) ? "Leave" : emp.shift_time
    );

    return {
      ...emp,
      name: emp.FullName,
      initials: emp.FullName?.split(" ")
        .map((n) => n[0])
        .join("")
        .slice(0, 2)
        .toUpperCase(),
      shifts,
    };
  });
  const getReportData = async () => {
    let details = await WebService({
      endPoint: `ShiftTiming/ShiftBoard`,
      method: "post",
      body: Date_Range,
      dispatch,
    });
    SetShiftData(details);
  };

  useEffect(() => {
    getReportData();
  }, [Date_Range]);

  const handleDateRangeChange = useCallback((StartDate, EndDate) => {
    const year = new Date(StartDate).getFullYear();
    setDate_Range((dt) => ({ ...dt, StartDate, EndDate }));
    setHolidayYear(year);  }, []);
  return (
    <Container className="base-container" fluid style={{ width: "98%" }}>
      <TopbarComponent bData={bData} HeadingText={MasterPageName} />
      <Box sx={{ p: 0 }}>
        <ThemeProvider theme={theme}>
          <AppBar
            style={{ minHeight: "50px", height: "50px", padding: 0 }}
            position="static"
            elevation={0}
            color={`${"primary"}`}
          >
            <Col
              key={"DateRange"}
              className="d-flex justify-content-center align-items-center col-auto py-1"
            >
              <WeeklyDatePicker
                onWeekChange={(WeekRange) => {
                  handleDateRangeChange(WeekRange.startDate, WeekRange.endDate);
                }}
              />
            </Col>
          </AppBar>
        </ThemeProvider>
      </Box>
      <div className="p-4 overflow-x-auto">
        <h2 className="text-2xl font-semibold mb-4">Shift Board</h2>
        <div className="container-fluid mt-4">
          <div className="table-responsive">
            <table className="table table-bordered align-middle text-center">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "200px" }}>Employee Name</th>
                  {WeekDays.map((day, idx) => (
                    <th key={idx}>
                      <span
                        className={`d-flex align-items-start justify-content-center gap-2 ${
                          WeekDays[idx].holiday ? "text-muted" : ""
                        }`}
                      >
                        <div className="fw-semibold h1">{day.date}</div>
                        <div className="d-flex flex-column">
                          <span className="fw-semibold">{day.day}</span>
                          <span className="text-muted small">{day.month}</span>
                          {day.holiday && (
                            <span className="text-muted  small  px-2 py-1">
                              {day.holidayName}
                            </span>
                          )}
                        </div>
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {formatted.map((emp, index) => (
                  <tr key={index}>
                    <td className="d-flex align-items-center justify-content-center gap-2">
                      <div
                        className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center"
                        style={{ width: "35px", height: "35px" }}
                      >
                        {emp.initials}
                      </div>
                      <span className="text-center">{emp.name}</span>
                    </td>
                    {emp.shifts.map((shift, idx) => (
                      <td key={idx}>
                        {typeof shift === "string" ? (
                          shift.toLowerCase().includes("weef off") ? (
                            <span className="text-muted">Weef off</span>
                          ) : shift.toLowerCase().includes("flexible") ? (
                            <div className="bg-success-subtle p-2 rounded">
                              <div>{shift}</div>
                              <div className="small text-muted">09 hrs.</div>
                            </div>
                          ) : shift.toLowerCase().includes("leave") ? (
                            <div className="bg-warning p-2 rounded ">
                              <FlightTakeoffRounded className="me-1" />
                              On leave
                            </div>
                          ) : (
                            <div className="bg-danger-subtle p-2 rounded">
                              <div
                                className={
                                  WeekDays[idx].holiday ? "text-muted" : ""
                                }
                              >
                                {shift}
                              </div>
                              <div className="small text-muted">09 hrs.</div>
                            </div>
                          )
                        ) : (
                          <div className="bg-light p-2 rounded text-primary cursor-pointer">
                            {shift}
                          </div>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default memo(ShiftBoard);
